import { render, staticRenderFns } from "./QPopup.vue?vue&type=template&id=39c5ab35&scoped=true"
import script from "./QPopup.vue?vue&type=script&lang=js"
export * from "./QPopup.vue?vue&type=script&lang=js"
import style0 from "./QPopup.vue?vue&type=style&index=0&id=39c5ab35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c5ab35",
  null
  
)

export default component.exports